import React, { useCallback, useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import { useHistory, useRouteMatch } from "react-router-dom";
import { connect } from "react-redux";

import SaveReward from "../../../components/Forms/SaveReward";
import RouteLeavingGuard from "../../../routes/middleware/RouteLeavingGuard";

import {
  clearRewardFetched,
  getReward,
  updateReward,
} from "../../../store/dashboard/Rewards/actions";
import ScrollbarVertical from "../../../components/Common/ScrollbarVertical";
import ProgressWatcher from "../../../components/Common/ProgressWatcher";
import SEO from "../../../components/Common/SEO";

const PROGRESS_TEXT = "Files are uploading now. Please, don't quit this page";

const Update = ({
  filesError,
  clearRewardFetched,
  getReward,
  updateReward,
  rewards,
}) => {
  const { updated, item, loading } = rewards;
  const [isDirty, updateDirty] = useState(false);
  const [ready, updateReadyState] = useState(false);
  const {
    params: { rewardId },
  } = useRouteMatch("/rewards/:rewardId");
  const history = useHistory();
  const saveRewardCallback = useCallback(
    (model) => {
      updateReward({ rewardId, model }, history);
    },
    [item]
  );
  const isBlocked = (updated ? false : isDirty) && !filesError;

  useEffect(() => {
    if (!ready && rewardId && !loading) {
      getReward(rewardId);
      updateReadyState(true);
    }
  }, [rewardId, ready, loading]);

  useEffect(() => {
    return () => {
      clearRewardFetched();
    };
  }, []);

  return (
    <>
      <SEO title="Edit Reward" />
      <RouteLeavingGuard
        contentText="Changed data will not be saved. Are you sure you want to cancel?"
        when={isBlocked}
        navigate={(path) => history.push(path)}
        shouldBlockNavigation={() => {
          return isBlocked;
        }}
      />
      <ProgressWatcher loading={loading} contentText={PROGRESS_TEXT} />
      <ScrollbarVertical>
        <Row className="page-content h-100">
          <Container fluid className="h-100">
            <Row>
              <Col xs="12">
                <div className="page-title-box d-flex align-items-center justify-content-between">
                  <h4 className="mb-0 font-size-18 text-uppercase">
                    Edit Reward
                  </h4>
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs="12" className="pb-4">
                {item && (
                  <SaveReward
                    model={item}
                    saveRewardFunc={saveRewardCallback}
                    updateDirtyState={updateDirty}
                  />
                )}
              </Col>
            </Row>
          </Container>
        </Row>
      </ScrollbarVertical>
    </>
  );
};

const mapStateToProps = ({ Progress, Rewards }) => {
  return { filesError: Progress.error, rewards: Rewards };
};

export default connect(mapStateToProps, {
  clearRewardFetched,
  getReward,
  updateReward,
})(Update);
